import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import cx from 'classnames';
import styles from './index.less';
import { cancelIdleCallback, requestIdleCallback } from '@xfe-team/idle-callback/lib/@xfe-team/idle-callback.js';

const CSS_PREFIX = 'xfe-route-animate';

export default class RouteAnimate extends React.PureComponent {
  /**
   * 是否是首次 animate, 用于判断首次动画
   * @type {boolean}
   */
  static isFirstAnimate = true;

  constructor(props) {
    super(props);
    this.state = {
      isFirstAnimate: RouteAnimate.isFirstAnimate,
      isIdle: false
    };
  }

  componentDidMount() {
    this.requestIdleCallbackHook = requestIdleCallback(() => this.setState({ isIdle: true }), { timeout: 200 /* 考虑大量测试一般浮动20-100之间 */ });
    RouteAnimate.isFirstAnimate = false;
  }

  componentWillUnmount() {
    cancelIdleCallback(this.requestIdleCallbackHook);
  }

  render() {
    const { children, className, history = {}, disableFirstRouteAnimate, effect } = this.props;
    const { isIdle, isFirstAnimate } = this.state;
    /**
     * @type {'push' | 'replace' | 'pop'}
     */
    let routeAction = history.action ? history.action.toLowerCase() : 'push';
    if (isFirstAnimate) {
      routeAction = 'push';
    }

    if (!isIdle) {
      return null;
    }

    const content = <div className={cx(styles.root, className)}>{children}</div>;

    if (disableFirstRouteAnimate && document.readyState !== 'complete') {
      return content;
    }

    let transitionName = effect === 'slide' ? `${CSS_PREFIX}-${effect}-${routeAction}` : `${CSS_PREFIX}-${effect}`;

    return (
      <ReactCSSTransitionGroup
        transitionAppear={true}
        transitionAppearTimeout={800}
        transitionEnterTimeout={800}
        transitionLeaveTimeout={800}
        transitionName={transitionName}
      >
        {content}
      </ReactCSSTransitionGroup>
    );
  }
}

RouteAnimate.defaultProps = {
  effect: 'fade'
};
